import { useTranslation } from 'react-i18next';
import { RegisterSubtitle, RegisterTitle } from './Register.styles';

const RegisterPageTitle = () => {
  const { t } = useTranslation();

  return (
    <>
      <RegisterTitle data-testid="register-title">
        {t('pageRegister.title')}
      </RegisterTitle>
      <RegisterSubtitle data-testid="register-subtitle">
        {t('pageRegister.subtitle')}
      </RegisterSubtitle>
    </>
  );
};

export default RegisterPageTitle;
